module.exports = __webpack_public_path__ + "img/ava-4.ba61c026.png";